
function Home() {
    return (
        <div>
            <h1>Home</h1>
            <div className='avatar'>
                
            </div>
            <h5>Illustrations by Angela Bello | Animation in Midjourney</h5>
        </div>
    );
}

export default Home